import {IBase64File} from './base64-file.model.interface';

export enum LegalCaseExportMode {
  DOWNLOAD = 'DOWNLOAD',
  EMAIL = 'EMAIL'
}

export interface ILegalCaseExportResponse {
  mode: LegalCaseExportMode;
  file: IBase64File | null;
}
